<template>
  <div>
    <v-dialog v-model="isAditionalFormOpen" max-width="1200" persistent>
      <v-card>
        <v-card-title>
          <div class="d-flex align-center justify-space-between w-100">
            <h1>Novo Adicional</h1>

            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-form ref="aditionalForm">
            <v-row class="mt-3">
              <v-col cols="12" md="5">
                <v-autocomplete
                  label="Nome do Embarcador"
                  v-model="aditional.sender"
                  :items="senders"
                  item-text="name"
                  item-value="id"
                  :rules="[rules.required]"
                  return-object
                  clearable
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  label="Tipo"
                  v-model="aditional.isDiscount"
                  :items="isDiscountItems"
                  :rules="[rules.aditionalType]"
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  ref="price"
                  label="Valor"
                  v-model="aditional.price"
                  v-money="money"
                  type="text"
                  :rules="[rules.hasPrice]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  label="Justificativa"
                  v-model="aditional.justification"
                  :disabled="shouldDisableJustification"
                  :items="justifications"
                  item-text="name"
                  :rules="[rules.required]"
                  return-object
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  ref="accessKeyCte"
                  label="Chave CTE"
                  v-model="aditional.accessKeyCte"
                  v-mask="'############################################'"
                  type="text"
                  :rules="[rules.required]"
                  :error-messages="validateKeyCteRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedDate"
                      label="Data"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="aditional.additionalDate" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="5">
                <v-file-input
                  hide-details
                  v-model="file"
                  class="file-input"
                  accept=".xml, text/xml"
                  :label="file ? 'Arquivo Selecionado: ' : 'Importar Arquivo XML'"
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row class="mt-5">
              <v-col cols="12" class="d-flex align-center pt-1">
                <v-text-field label="Observação" v-model="aditional.observation" hide-details></v-text-field>

                <v-btn
                  :disabled="shouldDisableAddButton"
                  class="ml-4 mb-1 align-self-end"
                  color="success"
                  :loading="isButtonAddLoading"
                  @click="addAditional"
                  large
                >
                  Adicionar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
          <div class="w-100">
            <div class="my-4">
              <h1>Descrição de Adicionais</h1>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="aditionalsHeaders"
                :items="aditionals"
                no-data-text="Nenhum adicional adicionado"
                hide-default-footer
              >
                <template v-slot:[`item.sender`]="{ item }">
                  <span>
                    {{ getSenderName(item.sender) }}
                  </span>
                </template>
                <template v-slot:[`item.isDiscount`]="{ item }">
                  <span> {{ getAditionalType(item.isDiscount) }}</span>
                </template>
                <template v-slot:[`item.price`]="{ item }">
                  <span> {{ formatPrice(item.price) }}</span>
                </template>
                <template v-slot:[`item.additionalDate`]="{ item }">
                  <span> {{ formatDate(item.additionalDate) }}</span>
                </template>
                <template v-slot:[`item.justification`]="{ item }">
                  <span>
                    {{ getJustificationName(item.justification) }}
                  </span>
                </template>
                <template v-slot:[`item.accessKeyCte`]="{ item }">
                  <TruncateDataWithTooltip
                    :data="item.accessKeyCte"
                    :lengthDataToTruncate="10"
                  ></TruncateDataWithTooltip>
                </template>
                <template v-slot:[`item.file`]="{ item }">
                  <TruncateDataWithTooltip
                    :data="getFileName(item.file)"
                    :lengthDataToTruncate="10"
                  ></TruncateDataWithTooltip>
                </template>
                <template v-slot:[`item.observation`]="{ item }">
                  <TruncateDataWithTooltip
                    :data="item.observation"
                    :lengthDataToTruncate="10"
                  ></TruncateDataWithTooltip>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <div class="d-flex justify-center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" @click="editAditional(item)" icon color="info" dark>
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" @click="removeAditional(item)" icon color="red" dark>
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Deletar</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-center py-4" style="gap: 5px">
          <v-btn @click="close" color="red" dark class="px-4"> Cancelar </v-btn>
          <v-btn
            @click="createNewAditionals"
            :loading="isLoading"
            color="green"
            :disabled="shouldDisableConfirmButton"
            :dark="!shouldDisableConfirmButton"
            class="px-4"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MessagesError
      :errors="errors"
      :type="errorsType"
      :error500="error500"
      @closeMessages="(errors = []), (validateKeyCte = null)"
    />
  </div>
</template>

<script>
import { VMoney } from 'v-money';
import maskPrice from '@/utils/maskPrice';
import { stringToMoneyMask } from '@/handlers/MoneyHandler.js';
import { mapActions } from 'vuex';
import MessagesError from '@/components/MessagesError.vue';
import Base64Mixin from '@/mixins/base64.mixin';
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';

export default {
  props: {
    isOpen: {
      default: false,
      type: Boolean
    }
  },
  components: {
    MessagesError,
    TruncateDataWithTooltip
  },
  mixins: [Base64Mixin],
  directives: { money: VMoney },
  data: () => ({
    isLoading: false,
    isButtonAddLoading: false,
    aditional: {
      sender: null,
      isDiscount: null,
      price: null,
      justification: null,
      additionalDate: null,
      accessKeyCte: null,
      observation: null,
      documentImportXml: null
    },
    file: null,
    aditionals: [],
    senders: [],
    isDiscountItems: [
      { text: 'Crédito', value: false },
      { text: 'Débito', value: true }
    ],
    justifications: [],
    menu: false,
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false
    },
    rules: {
      required: (value) => !!value || 'Campo obrigatório!',
      aditionalType: (value) => value !== null || 'Campo obrigatório!',
      hasPrice: (value) => {
        return value !== 'R$ 0,00' || 'Campo obrigatório!';
      }
    },
    validateKeyCte: null,
    errors: [],
    errorsType: 'error',
    error500: null
  }),

  computed: {
    aditionalsHeaders() {
      return [
        {
          value: 'sender',
          text: 'NOME DO EMBARCADOR',
          sortable: false
        },
        {
          value: 'isDiscount',
          text: 'TIPO',
          sortable: false
        },
        {
          value: 'price',
          text: 'VALOR',
          sortable: false
        },
        {
          value: 'additionalDate',
          text: 'DATA',
          align: 'center',
          sortable: false
        },
        {
          value: 'accessKeyCte',
          text: 'CHAVE CTE',
          sortable: false
        },
        {
          value: 'file',
          text: 'CTE COMPLEMENTAR',
          sortable: false
        },
        {
          value: 'justification',
          text: 'JUSTIFICATIVA',
          sortable: false
        },
        {
          value: 'observation',
          text: 'OBSERVAÇÃO',
          sortable: false
        },
        {
          value: 'actions',
          align: 'end',
          text: '',
          sortable: false
        }
      ];
    },

    formattedDate() {
      const date = this.aditional.additionalDate;
      if (date === null) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    isAditionalFormOpen() {
      return this.isOpen;
    },

    shouldDisableAddButton() {
      const { sender, isDiscount, price, accessKeyCte, additionalDate, justification } = this.aditional;
      return (
        sender === null ||
        isDiscount === null ||
        this.transformPriceToSend(price) === 0 ||
        !accessKeyCte ||
        additionalDate === null ||
        justification === null
      );
    },

    shouldDisableJustification() {
      return this.aditional.isDiscount === null;
    },

    justificationsNumber() {
      return this.aditional.isDiscount ? 13 : 12;
    },

    shouldDisableConfirmButton() {
      return this.aditionals.length === 0;
    },

    validateKeyCteRules() {
      if (!this.validateKeyCte && this.validateKeyCte !== null) {
        const error = 'Chave da CTE não pertence ao embarcador ou não foi encontrado';
        return error;
      }

      return null;
    }
  },

  watch: {
    'aditional.isDiscount': {
      handler(newValue, oldIsDiscount) {
        if (oldIsDiscount !== null && oldIsDiscount !== newValue) {
          this.aditional.justification = null;
        }
        this.getAllJustifications();
      }
    },

    isAditionalFormOpen: {
      handler(isOpen) {
        if (isOpen) {
          setTimeout(() => {
            if (this.$refs['aditionalForm']) {
              this.$refs.aditionalForm.reset();
            }
          }, 0);
        }
      }
    }
  },

  async created() {
    await this.getAllSenders();
  },

  methods: {
    ...mapActions('AccountsReceivableStore', [
      'fetchAditionalsReceivable',
      'getSenders',
      'validateAccessKeyCte',
      'createAditionals'
    ]),
    ...mapActions('NfeStore', ['fetchJustificationsById']),

    async addAditional() {
      this.isButtonAddLoading = true;
      this.validateKeyCte = await this.isValidateKeyCte(this.aditional);
      if (this.validateKeyCte) {
        this.aditionals = [
          ...this.aditionals,
          {
            ...this.aditional,
            justification: this.aditional.justification,
            price: this.transformPriceToSend(this.aditional.price),
            file: this.file
          }
        ];

        this.resetAditional();
      }
      this.isButtonAddLoading = false;
    },

    async createNewAditionals() {
      try {
        this.isLoading = true;

        const additionalsBody = this.aditionals;
        let index = 0;
        for (const aditional of this.aditionals) {
          const { file } = aditional;
          if (file) {
            const dataFiles = await this.toBase64(file);
            const documentImportXml = {
              fileName: file.name,
              dataFiles: dataFiles.split('base64,')[1]
            };
            additionalsBody[index].documentImportXml = documentImportXml;
          }
          index++;
        }

        const data = await this.createAditionals(additionalsBody);
        if (data.success) {
          this.handleSuccessFeedback();
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (error) {
        console.error(error);
        this.errors = ['Opss, algo deu errado!'];
        this.errorsType = 'error';
      } finally {
        this.isLoading = false;
      }
    },

    editAditional(aditional) {
      this.resetAditional();
      let aditionalIndex = this.aditionals.indexOf(aditional);
      const aditionalToEdit = this.aditionals[aditionalIndex];
      this.aditionals.splice(aditionalIndex, 1);
      this.file = aditionalToEdit.file;
      this.aditional = { ...aditionalToEdit };
      this.$refs.price.$el.getElementsByTagName('input')[0].value = stringToMoneyMask(aditionalToEdit.price);
    },

    removeAditional(aditional) {
      const aditionalIndex = this.aditionals.indexOf(aditional);
      this.aditionals.splice(aditionalIndex, 1);
    },

    async getAllSenders() {
      try {
        this.senders = await this.getSenders();
      } catch (error) {
        console.error(error);
      }
    },

    async getAllJustifications() {
      try {
        this.justifications = await this.fetchJustificationsById(this.justificationsNumber);
      } catch (error) {
        console.error(error);
      }
    },

    async isValidateKeyCte(aditional) {
      const params = {
        senderId: aditional.sender.id,
        accessKeyCte: aditional.accessKeyCte
      };

      const validationResult = await this.validateAccessKeyCte(params);
      if (validationResult.success) {
        return true;
      }

      this.errors = validationResult.errors;
      this.errorsType = 'error';
      setTimeout(() => {
        this.errors = [];
        this.validateKeyCte = null;
      }, 5000);
      return false;
    },

    resetAditional() {
      if (this.$refs.aditionalForm) {
        this.$refs.price.$el.getElementsByTagName('input')[0].value = 0;
        this.$refs.aditionalForm.reset();
      }

      this.aditional = {
        sender: null,
        isDiscount: null,
        price: null,
        justification: null,
        additionalDate: null,
        accessKeyCte: null,
        observation: null
      };
      this.file = null;
    },

    transformPriceToSend(element) {
      if (!element) return null;
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return Number(money);
    },

    getAditionalType(isDiscount) {
      return isDiscount ? 'Débito' : 'Crédito';
    },

    formatDate(date) {
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    formatPrice(price) {
      return maskPrice(price);
    },

    getSenderName(sender) {
      return sender !== null ? sender.name : null;
    },

    getJustificationName(justification) {
      return justification !== null ? justification.name : null;
    },

    getFileName(file) {
      return file ? file.name.split('_')[0] : null;
    },

    handleSuccessFeedback() {
      const hasMoreThanOneAditional = this.aditionals.length > 1;
      this.errors = hasMoreThanOneAditional ? ['Adicionais criados com sucesso!'] : ['Adicional criado com sucesso!'];
      this.errorsType = 'success';
      this.$emit('shouldUpdateList');
      this.close();
      setTimeout(() => {
        this.errors = [];
      }, 3000);
    },

    reset() {
      this.aditionals = [];
      this.resetAditional();
    },

    close() {
      this.reset();
      this.$emit('update:isOpen', false);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-file-input__text {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-wrap: wrap;
  top: -6px !important;
  position: relative !important;
  left: 145px !important;
  width: auto !important;
}

::v-deep .v-select__slot .v-input__append-inner.v-input__append-inner .v-input__icon--clear {
  padding-top: 17px;
}

.file-input ::v-deep .v-input__append-inner.v-input__append-inner .v-input__icon--clear {
  margin-right: 10px;
  margin-top: -5px;
}

::v-deep.v-select.v-select--chips .v-select__selections {
  min-height: 50px;
}

::v-deep.v-input__slot {
  margin: 0;
  padding: 0;

  &::after,
  &::before {
    display: none !important;
  }
}
::v-deep.v-input {
  .v-text-field {
    &__details {
      padding-top: 4px;
      display: inline-block;
    }
  }
}
</style>
